import isEmpty from 'lodash/isEmpty';
import flow from 'lodash/flow';
import partial from 'lodash/partial';

import splitHashParams from './splitHashParams';
import splitUrl from './splitUrl';

const stripFromString = (regexOrString: string | RegExp, string = '') =>
  string.replace(regexOrString, '');

export const stripLeadingSlash = partial(stripFromString, /^\/+/);
export const stripTrailingSlash = partial(stripFromString, /\/+$/);
const stripTerminalSlashes = flow(stripLeadingSlash, stripTrailingSlash);

/**
 * Strips possible leading and trailing slashes and
 * then adds them back to ensure they're always there
 * and not doubled up. It's important to have the slashes
 * to prevent something like `/dashboard` from matching
 * `/dashboard-items` which is likely a completely
 * different route.
 *
 * If the `retainHashOrQuery` argument is passed as truthy, then it
 * will retain the hash or query string attached to the original `pathname`.
 */
const normalizePathname = (pathname: string, retainHashOrQuery = false) => {
  const query = splitUrl(pathname);
  const hash = splitHashParams(query.baseHref);

  const cleanPath = `/${stripTerminalSlashes(hash.baseHref)}/`;

  if (retainHashOrQuery) {
    const hashStr = isEmpty(hash.queryString) ? '' : `#${hash.queryString}`;
    const queryStr = isEmpty(query.queryString) ? '' : `?${query.queryString}`;

    return `${cleanPath}${queryStr}${hashStr}`;
  }

  return cleanPath;
};

export default normalizePathname;
